import { render, staticRenderFns } from "./AddPage.vue?vue&type=template&id=ba75fb06&scoped=true&"
import script from "./AddPage.vue?vue&type=script&lang=ts&"
export * from "./AddPage.vue?vue&type=script&lang=ts&"
import style0 from "./AddPage.vue?vue&type=style&index=0&id=ba75fb06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba75fb06",
  null
  
)

export default component.exports